import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AppConfig } from 'src/app/configs/app.config';
import { Status } from 'src/app/core/services/http/general/enums/status';
import { RosterSelectActions } from 'src/app/core/services/http/roster/enums/roster-select-actions';
import { RosterUploadFileType } from 'src/app/core/services/http/roster/enums/roster-upload-file-types';
import { FormValidators } from 'src/app/shared/form-error/form.validators';

function getBaseFormControls(overrides: Record<string, any> = {}) {
  const baseControls = {
    name: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(255)]],
    description: [null, [Validators.minLength(0), Validators.maxLength(500)]],
    type: [null, [Validators.required, FormValidators.onlyPositiveNumbers]],
    source: [null, [Validators.required]],
    sourceId: [null],
    file: [null],
    manualFile: [null, [FormValidators.limitFileSize(AppConfig.Api.maxUploadFileSizeMB)]],
    items: [null],
    itemsFromFile: [null],
    adults: [[]],
    status: [Status.Active, [Validators.required, FormValidators.onlyPositiveNumbers]],
    serverUpload: [null],
    manualUpload: [true],
    groupSelect: [null],
    groupSelectAction: [RosterSelectActions.Add, [Validators.required]],
    groupSelectActionState: [null],
  };

  return { ...baseControls, ...overrides };
}

export function getFormGroup(): UntypedFormGroup {
  return new UntypedFormBuilder().group({
    ...getBaseFormControls({ source: [RosterUploadFileType.Manual, [Validators.required]] }),
    ...getAdditionalControlsForFiltering()
  });
}

export function getFormGroupForSourceFilter(): UntypedFormGroup {
  return new UntypedFormBuilder().group({
    ...getBaseFormControls(),
    ...getAdditionalControlsForFiltering()
  });
}

export function getAdditionalControlsForFiltering(): Record<string, AbstractControl> {
  return new UntypedFormBuilder().group({
    scheduled: [],
    priority: [],
    activityType: []
  }).controls;
}
